const MAP: Array<[RegExp, string]> = [
  [/invalid login/i, "İstifadəçi adı və ya şifrə yanlışdır"],
  [/email not confirmed/i, "E-poçt ünvanınız hələ təsdiqlənməyib"],
  [/already registered|user already/i, "Bu istifadəçi adı artıq mövcuddur"],
  [/invalid email/i, "E-poçt ünvanı düzgün deyil"],
  [
    /weak[_\s-]?password|pwned|password.*(?:weak|compromised|leaked)|(?:weak|compromised|leaked).*password/i,
    "Bu şifrə çox zəifdir və ya məlumat sızmalarında aşkarlanıb. Daha güclü şifrə seçin",
  ],
  [/password should be at least/i, "Şifrə ən azı 6 simvol olmalıdır"],
  [/rate limit|too many requests/i, "Çox sayda cəhd oldu, bir azdan yenidən yoxlayın"],
  [/network|fetch failed/i, "İnternet bağlantısı ilə problem var"],
  [/jwt|not authenticated|unauthorized|401/i, "Sessiyanız bitib, yenidən daxil olun"],
  [/row-level security|permission denied|403/i, "Bu əməliyyat üçün icazəniz yoxdur"],
  [/duplicate key/i, "Bu məlumat artıq mövcuddur"],
  [/not found|404/i, "Məlumat tapılmadı"],
  [/payload too large|exceeded the maximum/i, "Fayl həcmi çox böyükdür"],
  [/timeout/i, "Əməliyyat çox uzun çəkdi, yenidən cəhd edin"],
];

/** Səhv mesajlarını Azərbaycan dilinə çevirir. */
export function azError(input: unknown, fallback = "Xəta baş verdi, yenidən cəhd edin"): string {
  const message =
    typeof input === "string" ? input : input instanceof Error ? input.message : "";
  if (!message) return fallback;
  for (const [re, text] of MAP) if (re.test(message)) return text;
  return /^[\x20-\x7E]+$/.test(message) ? fallback : message;
}
